import React, { Dispatch } from 'react';
import { FormControl, Input, InputLabel, Button, Box, Typography } from '@mui/material';
import { DICTIONARY } from 'shared/constants';
import { resetPassword } from 'aws-amplify/auth';

interface Props {
  dispatch: Dispatch<LoginAction>;
  state: LoginState;
}

const ResetPassword: React.FC<Props> = ({ dispatch, state }: Props) => {
  const {
    resetError, username,
  } = state;

  const handleCancel = () => {
    dispatch({ type: 'cancel password reset' });
  };

  const handleRequestSubmit = async () => {
    dispatch({ type: 'loading' });

    resetPassword({ username })
      .then(() => dispatch({ type: 'reset request sent' }))
      .catch((error) => dispatch(
        {
          type: 'reset error',
          error: error.message,
        },
      ));
  };

  return (
    <>
      <Typography sx={{ marginBottom: '2rem' }} variant="h5" component="h1">
        {DICTIONARY.ResetPasswordHeadline}
      </Typography>
      <Typography className="error-text">{resetError}</Typography>
      <form onSubmit={handleRequestSubmit}>
        <FormControl sx={{ marginBottom: '2rem', width: '100%' }}>
          <InputLabel htmlFor="username-input">
            {DICTIONARY.EmailAddress}
          </InputLabel>
          <Input
            id="username-input"
            value={username}
            onChange={(e) => dispatch({
              type: 'field',
              fieldName: 'username',
              payload: e.currentTarget.value.trim(),
            })}
          />
        </FormControl>
        <Box display="flex">
          <button
            className="button button--small"
            onClick={handleCancel}
            type="button"
          >
            {DICTIONARY.CancelReset}
          </button>
          <Button
            sx={{ marginLeft: 'auto' }}
            onClick={handleRequestSubmit}
            variant="contained"
            color="primary"
          >
            {DICTIONARY.SendCode}
          </Button>
        </Box>
      </form>
    </>
  );
};

export default ResetPassword;
